import axios from 'axios'
import qs from 'qs'
import { message } from 'ant-design-vue';
import router from '../router';
import store from '../store'
const h=axios.create({
    baseURL: '/api',
    timeout:10000
})
h.defaults.withCredentials = true

h.interceptors.request.use(
    config => {
        config.headers.Authorization = sessionStorage.getItem('token') || '';
        return config
    },
    error => {
        return Promise.reject(error)
    }
)
h.interceptors.response.use(
    response => {
        if(response.data.code == 401){
           message.warn(response.data.msg);
           sessionStorage.removeItem('token');
           store.dispatch('home/updateToken','');
           router.push('/login')
        }
        return response.data
    },
    error => {
        return Promise.reject(error.response)
    }
)

export default h;